import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = () => ({
    skills: [],
    skillsLoading: false,
    skillActionLoading: false,
});

export default {
    namespaced: true,
    actions,
    mutations,
    state,
    getters,
};